import { render } from "./CardSolicitacao.vue?vue&type=template&id=b727565e&scoped=true"
import script from "./CardSolicitacao.vue?vue&type=script&lang=js"
export * from "./CardSolicitacao.vue?vue&type=script&lang=js"

import "./CardSolicitacao.vue?vue&type=style&index=0&id=b727565e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b727565e"]])

export default __exports__